(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-custom"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ===== VARIANT SELECTION ===== */
  const variants = JSON.parse(document.getElementById('pdp-variant-data')?.textContent || '[]');
  const productData = JSON.parse(document.getElementById('pdp-product-data')?.textContent || '{}');
  const optBtns = document.querySelectorAll('.pdp__opt-btn');
  const varInput = document.getElementById('pdp-variant-id');
  const priceEl = document.getElementById('pdp-price');
  const compareEl = document.getElementById('pdp-compare-price');
  const saveEl = document.getElementById('pdp-save');
  const atcBtn = document.getElementById('pdp-atc');
  const skuEl = document.getElementById('pdp-sku');
  const stickyPrice = document.getElementById('pdp-sticky-price');
  const stickyWas = document.getElementById('pdp-sticky-was');
  const stickyImg = document.getElementById('pdp-sticky-img');
  const stickyVariant = document.getElementById('pdp-sticky-variant');
  let selected = {};

  optBtns.forEach(b => { if (b.classList.contains('pdp__opt-btn--on')) selected[b.dataset.optionIndex] = b.dataset.value; });

  optBtns.forEach(btn => {
    btn.addEventListener('click', function(){
      const idx = this.dataset.optionIndex, val = this.dataset.value;
      selected[idx] = val;
      const group = this.closest('.pdp__option-btns, .pdp__swatches');
      if (group) group.querySelectorAll('.pdp__opt-btn').forEach(b => {
        b.classList.remove('pdp__opt-btn--on');
        b.classList.remove('pdp__swatch--on');
      });
      this.classList.add('pdp__opt-btn--on');
      if (this.classList.contains('pdp__swatch')) this.classList.add('pdp__swatch--on');
      const label = document.getElementById('pdp-sel-' + idx);
      if (label) label.textContent = this.dataset.label || val;

      const match = variants.find(v => v.options.every((o,i) => selected[String(i)] === o));
      if (!match) return;
      varInput.value = match.id;
      const fmt = new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'});
      priceEl.textContent = fmt.format(match.price/100);
      if (stickyPrice) stickyPrice.textContent = fmt.format(match.price/100);

      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceEl.className = 'pdp__price-now';
        compareEl.innerHTML = '<s>'+fmt.format(match.compare_at_price/100)+'</s>';
        compareEl.style.display = '';
        const pct = Math.round((match.compare_at_price-match.price)/match.compare_at_price*100);
        saveEl.textContent = 'Save '+pct+'%'; saveEl.style.display = '';
        if (stickyPrice) stickyPrice.className = 'pdp__sticky-now';
        if (stickyWas) { stickyWas.textContent = fmt.format(match.compare_at_price/100); stickyWas.style.display = ''; }
      } else {
        priceEl.className = 'pdp__price-reg';
        compareEl.style.display = 'none'; saveEl.style.display = 'none';
        if (stickyPrice) stickyPrice.className = 'pdp__sticky-reg';
        if (stickyWas) stickyWas.style.display = 'none';
      }
      atcBtn.disabled = !match.available;
      atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);

      /* ===== SWITCH IMAGE — swap hero IMG src without DOM reflow =====
         Always source from match.featured_media.preview_image.src (authoritative per-variant).
         Comparing the hero element to the DOM target breaks when they're the same element
         (variant's image is at position 1): previous click overwrites hero.src, and
         `targetImg.src === heroImg.src` skips the swap-back. */
      const mediaId = match.featured_media?.id || null;
      const previewSrc = match.featured_media?.preview_image?.src;
      const heroImg = document.querySelector('.pdp__img-item--hero img');
      function sizeShopifySrc(src, w){
        if (!src) return src;
        var s = src.indexOf('//') === 0 ? ('https:' + src) : src;
        if (s.indexOf('width=') !== -1) return s.replace(/width=\d+/, 'width=' + w);
        return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
      }
      if (heroImg && previewSrc) {
        const heroSrc = sizeShopifySrc(previewSrc, 1600);
        if (heroImg.src !== heroSrc) {
          heroImg.src = heroSrc;
          if (heroImg.hasAttribute('srcset')) heroImg.removeAttribute('srcset');
          heroImg.alt = match.featured_media.alt || heroImg.alt;
        } else {
          /* Variant resolved but image is identical to what's showing (supplier
             gave one hero per top-color; cabinet/size variants share it). Pulse
             the swatch + hero so the user sees their click registered. */
          const clickedSwatch = this;
          clickedSwatch.classList.remove('pdp__swatch--pulse');
          heroImg.classList.remove('pdp__img--pulse');
          void clickedSwatch.offsetWidth;
          clickedSwatch.classList.add('pdp__swatch--pulse');
          heroImg.classList.add('pdp__img--pulse');
          setTimeout(function(){
            clickedSwatch.classList.remove('pdp__swatch--pulse');
            heroImg.classList.remove('pdp__img--pulse');
          }, 500);
        }
      }
      if (mediaId) {
        const targetId = String(mediaId);
        /* Update thumbnail active state */
        const thumb = document.querySelector('.pdp__thumb[data-media-id="' + targetId + '"]');
        if (thumb) {
          document.querySelectorAll('.pdp__thumb').forEach(t => t.classList.remove('pdp__thumb--active'));
          thumb.classList.add('pdp__thumb--active');
        }
      }

      /* Single-stage gallery: the variant image is swapped into the hero, so make the
         hero the visible stage (in case the shopper was viewing another media/video). */
      const heroItem = document.querySelector('.pdp__img-item--hero');
      if (heroItem) {
        document.querySelectorAll('.pdp__img-item').forEach(it => it.classList.remove('pdp__img-item--active'));
        heroItem.classList.add('pdp__img-item--active');
        const playing = document.querySelector('.pdp__img-item video');
        if (playing) { try { playing.pause(); } catch (e) {} }
      }

      /* Sync sticky bar image to variant's image */
      if (stickyImg && previewSrc) {
        stickyImg.src = sizeShopifySrc(previewSrc, 88);
      }

      /* Sync sticky bar variant label (e.g. "Gold", "42 inch") */
      if (stickyVariant) {
        stickyVariant.textContent = match.title || match.options.join(' / ');
      }
    });
  });

  /* ===== QUANTITY ===== */
  document.querySelectorAll('.pdp__qty-btn').forEach(b => {
    b.addEventListener('click', function(){
      const inp = document.getElementById('pdp-qty');
      let v = parseInt(inp.value)||1;
      if (this.dataset.action==='increase') v++; else if (v>1) v--;
      inp.value = v;
      syncAddOnQuantities(v);
    });
  });
  document.getElementById('pdp-qty')?.addEventListener('input', function(){
    var v = Math.max(1, parseInt(this.value, 10) || 1);
    this.value = v;
    syncAddOnQuantities(v);
  });

  /* ===== ADD-ON QTY SYNC ===== */
  /* When main product qty changes, default protection plan + bundle child qtys to match.
     Stepper shows only when main qty > 1 (no point in stepper when there's just 1). */
  function syncAddOnQuantities(mainQty) {
    mainQty = Math.max(1, parseInt(mainQty, 10) || 1);
    var showSteppers = mainQty > 1;

    // Protection plan
    var protectWrap = document.getElementById('pdp-protect-qty-wrap');
    var protectInput = document.getElementById('pdp-protect-qty');
    if (protectWrap && protectInput) {
      protectWrap.hidden = !showSteppers;
      protectInput.max = mainQty;
      // Default to main qty whenever main changes (user can override after).
      protectInput.value = mainQty;
      var dec = protectWrap.querySelector('[data-protect-qty="dec"]');
      var inc = protectWrap.querySelector('[data-protect-qty="inc"]');
      if (dec) dec.disabled = mainQty <= 1;
      if (inc) inc.disabled = false;
    }

    // Bundle child items (rendered dynamically by initBundle — selector matches whatever's in DOM now)
    document.querySelectorAll('[data-bundle-qty-wrap]').forEach(function(wrap){
      wrap.hidden = !showSteppers;
      var input = wrap.querySelector('[data-bundle-qty-input]');
      if (input) {
        input.max = mainQty;
        input.value = mainQty;
      }
      var dec = wrap.querySelector('[data-bundle-qty="dec"]');
      var inc = wrap.querySelector('[data-bundle-qty="inc"]');
      if (dec) dec.disabled = mainQty <= 1;
      if (inc) inc.disabled = false;
    });
  }
  // Expose so initBundle (deferred) can call after rendering bundle items
  window.HCS_SYNC_ADDON_QTY = syncAddOnQuantities;

  /* Protection plan stepper handlers (own buttons; cap at main qty) */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-protect-qty]');
    if (!btn) return;
    var input = document.getElementById('pdp-protect-qty');
    if (!input) return;
    var mainQty = parseInt(document.getElementById('pdp-qty')?.value || 1, 10);
    var cur = parseInt(input.value, 10) || 1;
    var dir = btn.dataset.protectQty;
    var next = dir === 'inc' ? Math.min(mainQty, cur + 1) : Math.max(1, cur - 1);
    input.value = next;
  });
  document.addEventListener('input', function(e){
    if (!e.target.matches('#pdp-protect-qty')) return;
    var mainQty = parseInt(document.getElementById('pdp-qty')?.value || 1, 10);
    var v = Math.max(1, Math.min(mainQty, parseInt(e.target.value, 10) || 1));
    e.target.value = v;
  });
  /* Bundle item stepper handlers (delegated; cap at main qty) */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-bundle-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-bundle-qty-wrap]');
    var input = wrap?.querySelector('[data-bundle-qty-input]');
    if (!input) return;
    var mainQty = parseInt(document.getElementById('pdp-qty')?.value || 1, 10);
    var cur = parseInt(input.value, 10) || 1;
    var dir = btn.dataset.bundleQty;
    var next = dir === 'inc' ? Math.min(mainQty, cur + 1) : Math.max(1, cur - 1);
    input.value = next;
  });

  /* ===== HCS PROTECTION PLAN — Pricing + Drawer + Cart Integration ===== */
  (function initProtectionPlan() {
    const price = variants[0] ? variants[0].price / 100 : 0;

    /* Pricing tiers with real Shopify variant IDs for the "HCS Protection Plan" product */
    const tiers = [
      { min: 0,    max: 100,  y3: 14.99,  y5: 22.99,  y3vid: 44847445377093, y5vid: 44847445835845 },
      { min: 100,  max: 200,  y3: 19.99,  y5: 29.99,  y3vid: 44847445409861, y5vid: 44847445868613 },
      { min: 200,  max: 300,  y3: 29.99,  y5: 44.99,  y3vid: 44847445442629, y5vid: 44847445901381 },
      { min: 300,  max: 400,  y3: 34.99,  y5: 49.99,  y3vid: 44847445475397, y5vid: 44847445934149 },
      { min: 400,  max: 500,  y3: 49.99,  y5: 69.99,  y3vid: 44847445508165, y5vid: 44847445966917 },
      { min: 500,  max: 700,  y3: 79.99,  y5: 109.99, y3vid: 44847445540933, y5vid: 44847445999685 },
      { min: 700,  max: 800,  y3: 89.99,  y5: 119.99, y3vid: 44847445573701, y5vid: 44847446032453 },
      { min: 800,  max: 1000, y3: 109.99, y5: 149.99, y3vid: 44847445606469, y5vid: 44847446065221 },
      { min: 1000, max: 1250, y3: 129.99, y5: 179.99, y3vid: 44847445639237, y5vid: 44847446097989 },
      { min: 1250, max: 1500, y3: 149.99, y5: 199.99, y3vid: 44847445672005, y5vid: 44847446130757 },
      { min: 1500, max: 2000, y3: 169.99, y5: 239.99, y3vid: 44847445704773, y5vid: 44847446163525 },
      { min: 2000, max: 2500, y3: 189.99, y5: 269.99, y3vid: 44847445737541, y5vid: 44847446196293 },
      { min: 2500, max: 3000, y3: 199.99, y5: 299.99, y3vid: 44847445770309, y5vid: 44847446229061 },
      { min: 3000, max: 99999,y3: 219.99, y5: 349.99, y3vid: 44847445803077, y5vid: 44847446261829 }
    ];

    function getTier(p) {
      return tiers.find(t => p >= t.min && p < t.max) || tiers[tiers.length - 1];
    }

    let tier = getTier(price);
    let selectedPlan = '5yr';
    /* Expose live protection state to OTHER IIFEs (bundle ATC needs it to include plan in payload). */
    window.HCS_PROTECT_STATE = function(){ return { selectedPlan: selectedPlan, tier: tier }; };
    const fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });

    function updateInline() {
      const planPrice = selectedPlan === '5yr' ? tier.y5 : tier.y3;
      const years = selectedPlan === '5yr' ? 5 : 3;
      const perYear = (planPrice / years).toFixed(2);
      const nameEl = document.getElementById('pdp-protect-plan-name');
      const priceEl = document.getElementById('pdp-protect-price');
      const perYrEl = document.getElementById('pdp-protect-peryear');
      if (nameEl) nameEl.textContent = years + ' Year Protection Plan';
      if (priceEl) priceEl.textContent = fmt.format(planPrice);
      if (perYrEl) perYrEl.textContent = '(' + fmt.format(parseFloat(perYear)) + '/year)';
    }

    function updateDrawerPrices() {
      document.querySelectorAll('.pdp__protect-opt-price').forEach(el => {
        const plan = el.dataset.plan;
        el.textContent = fmt.format(plan === '5yr' ? tier.y5 : tier.y3);
      });
      document.querySelectorAll('.pdp__protect-opt-yr').forEach(el => {
        const plan = el.dataset.plan;
        const p = plan === '5yr' ? tier.y5 : tier.y3;
        const y = plan === '5yr' ? 5 : 3;
        el.textContent = '(' + fmt.format(p / y) + '/year)';
      });
    }

    const protectSection = document.getElementById('pdp-protect');
    if (price < 100 && protectSection) { protectSection.style.display = 'none'; }

    updateInline();
    updateDrawerPrices();

    /* Drawer open/close */
    const drawer = document.getElementById('pdp-protect-drawer');
    const overlay = document.getElementById('pdp-protect-overlay');
    const detailsBtn = document.getElementById('pdp-protect-details-btn');
    const closeBtn = document.getElementById('pdp-protect-close');

    function openDrawer() {
      if (drawer) drawer.classList.add('pdp__protect-drawer--show');
      if (overlay) overlay.classList.add('pdp__protect-overlay--show');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('pdp__protect-drawer--show');
      if (overlay) overlay.classList.remove('pdp__protect-overlay--show');
      document.body.style.overflow = '';
    }

    if (detailsBtn) detailsBtn.addEventListener('click', function(e) { e.preventDefault(); openDrawer(); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* Radio button plan selection in drawer */
    document.querySelectorAll('.pdp__protect-option').forEach(opt => {
      opt.addEventListener('click', function() {
        document.querySelectorAll('.pdp__protect-option').forEach(o => o.classList.remove('pdp__protect-option--on'));
        this.classList.add('pdp__protect-option--on');
        this.querySelector('input[type="radio"]').checked = true;
        selectedPlan = this.dataset.plan;
        updateInline();
      });
    });

    /* "Add Protection" button in drawer */
    const addBtn = document.getElementById('pdp-protect-add-btn');
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        const checkbox = document.getElementById('pdp-protect-check');
        if (checkbox) checkbox.checked = true;
        closeDrawer();
      });
    }

    /* ===== CART INTEGRATION — AJAX ATC with drawer confirmation (HD/Lowe's/Wayfair pattern) ===== */
    const atcForm = document.getElementById('pdp-form');
    if (atcForm) {
      atcForm.addEventListener('submit', function(e) {
        /* ALWAYS intercept — never let default form submission redirect to /cart */
        e.preventDefault();

        const checkbox = document.getElementById('pdp-protect-check');
        const wantsPlan = checkbox && checkbox.checked;

        const variantId = document.getElementById('pdp-variant-id')?.value;
        const qtyEl = document.querySelector('.pdp__qty-input') || document.querySelector('[name="quantity"]');
        const quantity = parseInt(qtyEl?.value || 1);
        if (!variantId) return;

        const atcBtn = atcForm.querySelector('[type="submit"]');
        const originalText = atcBtn ? atcBtn.textContent : '';
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

        /* Build items — product + optional protection plan.
           Collect hidden properties[X] inputs (e.g. Drawer Side) so line
           item properties survive the manual fetch. Without this the form's
           defaults are lost because we bypass native form submit. */
        const mainItem = { id: parseInt(variantId), quantity: quantity };
        const props = {};
        atcForm.querySelectorAll('input[name^="properties["]').forEach(function(inp){
          const m = inp.name.match(/^properties\[(.+)\]$/);
          if (m && inp.value) props[m[1]] = inp.value;
        });
        if (Object.keys(props).length > 0) mainItem.properties = props;
        const items = [mainItem];
        if (wantsPlan) {
          const planVariantId = selectedPlan === '5yr' ? tier.y5vid : tier.y3vid;
          const years = selectedPlan === '5yr' ? 5 : 3;
          const productTitle = (document.querySelector('.pdp__title')?.textContent || 'Product').trim();
          // Read user-overridable plan qty (defaults to main qty, capped at main qty).
          const protectQtyInput = document.getElementById('pdp-protect-qty');
          const planQty = Math.max(1, Math.min(quantity, parseInt(protectQtyInput?.value || quantity, 10) || quantity));
          items.push({
            id: planVariantId,
            quantity: planQty,
            properties: { '_Protected Product': productTitle, '_Protected Variant': String(variantId), '_Plan Term': years + ' Year' }
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(r => r.json().then(d => ({ ok: r.ok, status: r.status, body: d })))
        .then(({ ok, status, body }) => {
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText || 'Add to Cart'; }
          if (!ok) {
            console.error('PDP ATC failed', status, body);
            alert('Could not add to cart: ' + ((body && body.description) || ('HTTP ' + status)));
            return;
          }
          /* Uncheck PP so it doesn't carry into the next variant's ATC */
          const ppCbMain = document.getElementById('pdp-protect-check');
          if (ppCbMain) ppCbMain.checked = false;
          /* Show confirmation drawer.
             Phase 4 hardening 2026-04-17: retry + event dispatch fallback in case
             the header IIFE hasn't defined HCS_OPEN_ATC_DRAWER yet when ATC fires. */
          (function openDrawerWithRetry(){
            var tries = 0;
            var tryOpen = function(){
              if (typeof window.HCS_OPEN_ATC_DRAWER === 'function') {
                window.HCS_OPEN_ATC_DRAWER(body);
                return;
              }
              if (++tries < 8) return setTimeout(tryOpen, 80);
              /* Fallback: dispatch event the header drawer is also listening for */
              document.dispatchEvent(new CustomEvent('hcs:atc:success', { detail: body }));
            };
            tryOpen();
          })();
          /* Update cart icon badge */
          fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).then(c => {
            document.querySelectorAll('[data-cart-count], .cart-count, #cart-count').forEach(el => { el.textContent = c.item_count; });
          });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch((err) => {
          console.error('PDP ATC network error', err);
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText || 'Add to Cart'; }
          alert('Network error adding to cart. Please try again.');
        });
      });
    }

    /* Update prices when variant changes */
    document.querySelectorAll('.pdp__opt-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        setTimeout(() => {
          const match = variants.find(v => v.id === parseInt(document.getElementById('pdp-variant-id')?.value));
          if (match) {
            tier = getTier(match.price / 100);
            updateInline();
            updateDrawerPrices();
          }
        }, 100);
      });
    });
  })();

  /* ===== FULFILLMENT CARDS — Fully Interactive (Lowe's/Rona-style) ===== */
  (function initFulfillment() {
    const STORES = [
      { name: 'Vaughan', addr: '201 Whitmore Rd, Woodbridge, ON', lat: 43.7944, lng: -79.5350 },
      { name: 'Burlington', addr: '4181 Fairview St, Burlington, ON', lat: 43.3255, lng: -79.7990 }
    ];
    const TORONTO = { lat: 43.6532, lng: -79.3832 };
    /* Rate calculation via shared HCS_SHIPPING (hcs-shipping-calculator.liquid) */

    /* Delivery/pickup date calculation — skip weekends, big-box date format */
    function addBizDays(from, days) {
      var d = new Date(from); var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
      return d;
    }
    function fmtDateRange(minDays, maxDays) {
      var now = new Date();
      var mn = addBizDays(now, minDays), mx = addBizDays(now, maxDays);
      var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      if (mn.getMonth() === mx.getMonth()) {
        return mo[mn.getMonth()] + ' ' + mn.getDate() + ' – ' + mx.getDate();
      }
      return mo[mn.getMonth()] + ' ' + mn.getDate() + ' – ' + mo[mx.getMonth()] + ' ' + mx.getDate();
    }
    /* PDP shows single end date (5th biz day). Fallback to local calc if HCS_DELIVERY not yet loaded. */
    var deliveryDateText = window.HCS_DELIVERY
      ? ('Get it by ' + HCS_DELIVERY.getState().deliveryDate)
      : ('Get it by ' + (function(){ var mo=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; var d=addBizDays(new Date(), 4); return mo[d.getMonth()]+' '+d.getDate(); })());
    var pickupDateText = 'Ready by ' + fmtDateRange(1, 2);

    const tp = (productData.type || '').toLowerCase();
    const tgs = (productData.tags || []).map(t => t.toLowerCase());
    const cls = (productData.collections || []).map(c => c.toLowerCase());
    const isVanity = tp.includes('vanit') || tgs.some(t => t.includes('vanit')) || cls.some(c => c.includes('vanit'));

    /* DOM refs */
    const storeEl = document.getElementById('pdp-ful-store');
    const pickupTime = document.getElementById('pdp-ful-pickup-time');
    if (pickupTime) pickupTime.textContent = pickupDateText;
    const delTime = document.getElementById('pdp-ful-del-time');
    const delArea = document.getElementById('pdp-ful-del-area');
    const delPrice = document.getElementById('pdp-ful-del-price');
    const delNote = document.getElementById('pdp-ful-del-note');
    const infoText = document.getElementById('pdp-ful-info-text');
    const actionBtn = document.getElementById('pdp-ful-action');
    const storesPanel = document.getElementById('pdp-ful-stores-panel');
    const deliveryPanel = document.getElementById('pdp-ful-delivery-panel');
    const storeList = document.getElementById('pdp-ful-store-list');

    /* Haversine km */
    function hav(a, b) {
      const R=6371, r=d=>d*Math.PI/180, dLat=r(b.lat-a.lat), dLng=r(b.lng-a.lng);
      const x=Math.sin(dLat/2)**2+Math.cos(r(a.lat))*Math.cos(r(b.lat))*Math.sin(dLng/2)**2;
      return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
    }

    /* Resolve location from coords — can't determine postal from coords, prompt user */
    function resolveFromCoords(lat, lng) {
      const sorted = STORES.map(s => ({...s, dist: hav({lat,lng}, s)})).sort((a,b) => a.dist-b.dist);
      return { nearest: sorted[0], stores: sorted, isLocal: null, postal: null };
    }

    /* Resolve location from postal code — uses 318-prefix LOCAL_ZONE via HCS_SHIPPING.
       Preserves full postal ("M5V 2T6") when given; falls back to FSA-only if input is 3 chars.
       Previously returned FSA-only, which downgraded stored full postals and caused
       setPostal('pdp') to fire on init (guard mismatch) → Task 10 Apr-19 IP-override bug. */
    function resolveFromPostal(pc) {
      const raw = String(pc || '').replace(/\s/g,'').toUpperCase();
      const postal = raw.length >= 6 ? (raw.substring(0,3) + ' ' + raw.substring(3,6)) : raw.substring(0,3);
      const isLocal = window.HCS_SHIPPING ? HCS_SHIPPING.isLocalZone(pc) : false;
      const nearest = STORES[0];
      const sorted = STORES.map(s => ({...s, dist: null}));
      return { nearest, stores: sorted, isLocal, postal: postal };
    }

    /* Update all UI based on location */
    function updateAll(loc) {
      /* Single write path — HCS_SHIPPING.setPostal handles storage + hcs:geo-updated dispatch.
         Dedup guard: only call when postal changed (storage listener re-entry breaks loop). */
      if (loc.postal && window.HCS_SHIPPING && typeof window.HCS_SHIPPING.setPostal === 'function') {
        var _cur = window.HCS_SHIPPING.getVisitorPostal && window.HCS_SHIPPING.getVisitorPostal();
        var _norm = String(loc.postal).trim().toUpperCase();
        if (_cur !== _norm) window.HCS_SHIPPING.setPostal(loc.postal, 'pdp');
      }
      /* globalGeoSwap (in hcs-shipping-calculator.liquid) handles data-hcs-geo + body class
         on every hcs:geo-updated. Keeping local swap for same-tick paint consistency. */
      var inGta = loc.isLocal || (loc.postal && window.HCS_SHIPPING && window.HCS_SHIPPING.isLocalZone(loc.postal));
      if (inGta) {
        document.querySelectorAll('[data-hcs-geo="gta"]').forEach(function(el){ el.style.display = ''; });
        document.querySelectorAll('[data-hcs-geo="default"]').forEach(function(el){ el.style.display = 'none'; });
        document.body.classList.add('hcs-gta-detected');
      } else if (loc.postal) {
        document.querySelectorAll('[data-hcs-geo="gta"]').forEach(function(el){ el.style.display = 'none'; });
        document.querySelectorAll('[data-hcs-geo="default"]').forEach(function(el){ el.style.display = ''; });
        document.body.classList.remove('hcs-gta-detected');
      }

      /* Pickup card */
      if (storeEl) storeEl.textContent = loc.nearest.name;

      /* Delivery card */
      function postalLink(pc) {
        return 'to <a href="#" class="pdp__ful-postal-link" id="pdp-ful-postal-click">' + pc + '</a>';
      }
      /* Calculate actual shipping rate using shared calculator */
      if (delTime) delTime.textContent = deliveryDateText;
      if (loc.postal && window.HCS_SHIPPING) {
        var shippingResult = HCS_SHIPPING.calcProductRate(loc.postal, (JSON.parse(document.getElementById('pdp-product-data')?.textContent||'{}').title)||'');
        if (delArea) delArea.innerHTML = postalLink(loc.postal);
        if (shippingResult.cents === 0) {
          if (delPrice) { delPrice.textContent = 'FREE'; delPrice.className = 'pdp__ful-price pdp__ful-price--free'; delPrice.style.display = ''; }
          if (delNote) delNote.innerHTML = 'Free delivery · ' + deliveryDateText;
        } else {
          if (delPrice) { delPrice.textContent = ''; delPrice.className = 'pdp__ful-price pdp__ful-price--calc'; delPrice.style.display = 'none'; }
          if (delNote) delNote.innerHTML = 'Rates calculated at checkout';
        }
      } else {
        if (delArea) delArea.innerHTML = 'Canada-wide';
        if (delPrice) { delPrice.textContent = ''; delPrice.className = 'pdp__ful-price pdp__ful-price--calc'; delPrice.style.display = 'none'; }
        if (delNote) delNote.innerHTML = 'Rates calculated at checkout';
      }
      /* Make postal code link open the delivery panel */
      var pcLink = document.getElementById('pdp-ful-postal-click');
      if (pcLink) {
        pcLink.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          if (deliveryPanel) { deliveryPanel.style.display = ''; if (storesPanel) storesPanel.style.display = 'none'; }
        });
      }

      /* Store list in panel */
      renderStoreList(loc);
      updateInfoBar();
    }

    /* Render store list */
    function renderStoreList(loc) {
      if (!storeList) return;
      storeList.innerHTML = (loc.stores || STORES.map(s=>({...s,dist:null}))).map((s, i) => {
        const isNearest = s.name === loc.nearest.name;
        const mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.addr);
        const distText = s.dist !== null ? s.dist.toFixed(1) + ' km away' : '';
        return '<div class="pdp__ful-store-card' + (isNearest ? ' pdp__ful-store-card--nearest' : '') + '" data-store-name="' + s.name.replace(/"/g,'&quot;') + '" role="button" tabindex="0" aria-label="Select ' + s.name + ' for pickup">' +
          (isNearest ? '<span class="pdp__ful-store-badge">Your Nearest Store</span>' : '<span class="pdp__ful-store-select">Select this store</span>') +
          '<div class="pdp__ful-store-name">' + s.name + '</div>' +
          '<div class="pdp__ful-store-addr">' + s.addr + '</div>' +
          '<div class="pdp__ful-store-meta">' +
            '<span class="pdp__ful-store-ready">' + pickupDateText + '</span>' +
            (distText ? '<span class="pdp__ful-store-dist">' + distText + '</span>' : '') +
          '</div>' +
          '<a href="' + mapsUrl + '" target="_blank" rel="noopener" class="pdp__ful-store-map">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>' +
            'View on Google Maps' +
          '</a>' +
        '</div>';
      }).join('');

      /* Wire click handlers — select this store as nearest, update Pickup tab + info bar, persist */
      storeList.querySelectorAll('.pdp__ful-store-card').forEach(function(card){
        function selectStore(e){
          /* Ignore clicks on the inner "View on Google Maps" anchor */
          if (e.target.closest('.pdp__ful-store-map')) return;
          var name = card.dataset.storeName;
          var store = STORES.find(function(x){ return x.name === name; });
          if (!store) return;
          var newLoc = Object.assign({}, JSON.parse(localStorage.getItem('hcs_location')||'{}'), { nearest: store });
          updateAll(newLoc);
          /* Close the panel after selection */
          if (storesPanel) storesPanel.style.display = 'none';
        }
        card.addEventListener('click', selectStore);
        card.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectStore(e); } });
      });
    }

    /* Update info bar text + action link */
    function updateInfoBar() {
      const active = document.querySelector('.pdp__ful-card--on');
      if (!active || !infoText || !actionBtn) return;
      const type = active.dataset.ful;
      const loc = JSON.parse(localStorage.getItem('hcs_location') || '{}');
      const store = loc.nearest ? loc.nearest.name : 'Vaughan';

      if (type === 'pickup') {
        infoText.innerHTML = 'FREE Pickup at <strong>' + store + '</strong> store';
        actionBtn.textContent = 'Check Other Stores';
        actionBtn.dataset.panel = 'stores';
      } else {
        if (loc.postal && window.HCS_SHIPPING) {
          var infoShipping = HCS_SHIPPING.calcProductRate(loc.postal, (JSON.parse(document.getElementById('pdp-product-data')?.textContent||'{}').title)||'');
          if (infoShipping.cents === 0) {
            infoText.innerHTML = '<strong style="color:#2d5a3d;">FREE delivery</strong> to ' + loc.postal + ' · ' + deliveryDateText;
          } else {
            infoText.innerHTML = deliveryDateText + ' to ' + loc.postal + ' · Rates calculated at checkout';
          }
        } else {
          infoText.innerHTML = deliveryDateText + ' · Enter postal code for shipping rate';
        }
        actionBtn.textContent = 'Enter postal code';
        actionBtn.dataset.panel = 'delivery';
      }
    }

    /* Card switching */
    document.querySelectorAll('.pdp__ful-card').forEach(card => {
      card.addEventListener('click', function() {
        document.querySelectorAll('.pdp__ful-card').forEach(c => c.classList.remove('pdp__ful-card--on'));
        this.classList.add('pdp__ful-card--on');
        /* Close any open panel */
        if (storesPanel) storesPanel.style.display = 'none';
        if (deliveryPanel) deliveryPanel.style.display = 'none';
        updateInfoBar();
      });
    });

    /* Action button (Check Other Stores / Enter postal code) */
    if (actionBtn) {
      actionBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const panel = this.dataset.panel;
        if (panel === 'stores' && storesPanel) {
          storesPanel.style.display = storesPanel.style.display === 'none' ? '' : 'none';
          if (deliveryPanel) deliveryPanel.style.display = 'none';
        } else if (panel === 'delivery' && deliveryPanel) {
          deliveryPanel.style.display = deliveryPanel.style.display === 'none' ? '' : 'none';
          if (storesPanel) storesPanel.style.display = 'none';
        }
      });
    }

    /* Close panel buttons */
    document.querySelectorAll('.pdp__ful-panel-close').forEach(btn => {
      btn.addEventListener('click', function() {
        this.closest('.pdp__ful-panel').style.display = 'none';
      });
    });

    /* Postal code check — Delivery */
    const postalDelInput = document.getElementById('pdp-ful-postal-delivery');
    const postalDelBtn = document.getElementById('pdp-ful-postal-del-btn');
    if (postalDelBtn && postalDelInput) {
      function checkDeliveryPostal() {
        const pc = postalDelInput.value.trim();
        if (pc.length < 3) return;
        if (window.HCS_SHIPPING && typeof window.HCS_SHIPPING.setPostal === 'function') {
          window.HCS_SHIPPING.setPostal(pc, 'user');
        }
        const loc = resolveFromPostal(pc);
        updateAll(loc);
        deliveryPanel.style.display = 'none';
      }
      postalDelBtn.addEventListener('click', checkDeliveryPostal);
      postalDelInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkDeliveryPostal(); });
    }

    /* Postal code check — Stores */
    const postalStoresInput = document.getElementById('pdp-ful-postal-stores');
    const postalStoresBtn = document.getElementById('pdp-ful-postal-stores-btn');
    if (postalStoresBtn && postalStoresInput) {
      function checkStoresPostal() {
        const pc = postalStoresInput.value.trim();
        if (pc.length < 3) return;
        if (window.HCS_SHIPPING && typeof window.HCS_SHIPPING.setPostal === 'function') {
          window.HCS_SHIPPING.setPostal(pc, 'user');
        }
        const loc = resolveFromPostal(pc);
        updateAll(loc);
      }
      postalStoresBtn.addEventListener('click', checkStoresPostal);
      postalStoresInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkStoresPostal(); });
    }

    /* Geolocation detect buttons */
    function geoDetect(callback) {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        pos => { callback(resolveFromCoords(pos.coords.latitude, pos.coords.longitude)); },
        () => { alert('Location access denied. Please enter your postal code manually.'); },
        { timeout: 8000 }
      );
    }

    const detectStores = document.getElementById('pdp-ful-detect-stores');
    if (detectStores) {
      detectStores.addEventListener('click', function() {
        this.textContent = 'Detecting...';
        geoDetect(loc => { updateAll(loc); storesPanel.style.display = 'none'; this.textContent = 'Use Current Location'; });
      });
    }
    const detectDelivery = document.getElementById('pdp-ful-detect-delivery');
    if (detectDelivery) {
      detectDelivery.addEventListener('click', function() {
        this.textContent = 'Detecting...';
        geoDetect(loc => { updateAll(loc); deliveryPanel.style.display = 'none'; this.textContent = 'Use Current Location'; });
      });
    }

    /* Init: only render rate when we have a REAL postal. If unknown, leave UI in
       default "Enter postal" state — never falsely claim FREE. IP auto-detect
       (hcs-shipping-calculator.liquid) will populate postal and fire a storage event. */
    function waitForShipping(cb, tries) {
      tries = tries || 0;
      if (window.HCS_SHIPPING) return cb();
      if (tries > 30) return cb();
      setTimeout(function(){ waitForShipping(cb, tries + 1); }, 100);
    }
    waitForShipping(function(){
      var savedPostal = null;
      try {
        var s = localStorage.getItem('hcs_location');
        if (s) { var loc = JSON.parse(s); if (loc && loc.postal) savedPostal = loc.postal; }
        if (!savedPostal) savedPostal = localStorage.getItem('hcs_m_postal');
      } catch(e) {}
      if (savedPostal) {
        updateAll(resolveFromPostal(savedPostal));
      }
      /* No postal yet: default markup ("Enter postal") stays visible until user enters one or IP detects one */
    });

    /* Cross-tab sync — when postal changes in another tab, re-run rate calc here */
    window.addEventListener('storage', function(e){
      if (e.key !== 'hcs_m_postal' && e.key !== 'hcs_location') return;
      var newPostal = null;
      try {
        if (e.key === 'hcs_location' && e.newValue) {
          var loc = JSON.parse(e.newValue);
          if (loc && loc.postal) newPostal = loc.postal;
        } else if (e.key === 'hcs_m_postal' && e.newValue) {
          newPostal = e.newValue;
        }
      } catch(err) {}
      if (newPostal) updateAll(resolveFromPostal(newPostal));
    });
  })();

  /* ===== BUNDLE / COMPLETE THE INSTALL ===== */
  function initBundle() {
    const bundleItems = document.getElementById('pdp-bundle-items');
    const bundleFooter = document.getElementById('pdp-bundle-footer');
    const bundleWas = document.getElementById('pdp-bundle-was');
    const bundleNow = document.getElementById('pdp-bundle-now');
    const bundleAtc = document.getElementById('pdp-bundle-atc');
    const bundleSection = document.getElementById('pdp-bundle');
    if (!bundleItems || !bundleSection) return;

    const tp = (productData.type || '').toLowerCase();
    const tgs = (productData.tags || []).map(t => t.toLowerCase());
    const colls = (productData.collections || []).map(c => c.toLowerCase());
    const isVanity = tp.includes('vanit') || tgs.some(t => t.includes('vanit')) || colls.some(c => c.includes('vanit'));
    const isDoor = tp.includes('door') || tgs.some(t => t.includes('door')) || colls.some(c => c.includes('door'));

    if (!isVanity && !isDoor) { bundleSection.remove(); return; }

    /* Current product info (locked item at top) */
    const currentVid = parseInt(document.getElementById('pdp-variant-id')?.value) || variants[0].id;
    const currentVar = variants.find(v => v.id === currentVid) || variants[0];
    const currentPrice = currentVar.price / 100;
    const currentImg = productData.featured_image || '';

    /* Curated bundle products */
    let fetchPromises;
    if (isVanity) {
      /* Mirror size should track the vanity — pick the largest mirror variant that
         fits within the vanity's width. E.g., 42" vanity → 41" mirror, 48" → 47",
         60" → 59". Pinned to a specific variant ID so the bundle adds the right
         SKU to cart. If width can't be parsed from the title, fall back to 35" (mid). */
      const MIRROR_TIERS = [
        { size: 24, vid: 42976103366725 },
        { size: 28, vid: 42976103399493 },
        { size: 35, vid: 42976103432261 },
        { size: 41, vid: 42976103465029 },
        { size: 47, vid: 42976103497797 },
        { size: 59, vid: 42976103530565 }
      ];
      function pickMirrorVidForVanity(title){
        /* Parse first 2-digit number preceded by anything up to 3 digits and followed
           by a common width separator (quote, inch, space, hyphen). Handles "Tesoro 42\"",
           "36-inch", "48 Inch Vanity", "60\" Double Sink" etc. */
        if (!title) return 42976103432261; /* safe default: 35" */
        var match = String(title).match(/\b(\d{2,3})\s*["″''\-]?\s*(?:inch|in\b|")/i) || String(title).match(/\b(\d{2,3})\b/);
        var w = match ? parseInt(match[1], 10) : 0;
        if (!w || w < 24) return MIRROR_TIERS[0].vid;
        var best = MIRROR_TIERS[0].vid;
        for (var i = 0; i < MIRROR_TIERS.length; i++) {
          if (MIRROR_TIERS[i].size <= w) best = MIRROR_TIERS[i].vid;
        }
        return best;
      }
      const mirrorVid = pickMirrorVidForVanity(productData.title);
      /* Fixed curated set for all vanity PDPs: Faucet → Drain → Mirror(size-matched) → Toilet */
      const vanityBundle = [
        { handle: 'kodaen-madison-single-hole-bathroom-faucet', variantId: null },
        { handle: 'aqua-solid-brass-pop-up-drain-no-overflow', variantId: null },
        { handle: 'cleo-embrace-bathroom-led-vanity-mirror', variantId: mirrorVid },
        { handle: 'dual-flush-elongated-one-piece-toilet-bowl-soft-close-seat-with-high-efficiency-dual-flush-in-white', variantId: null }
      ];
      fetchPromises = vanityBundle.map(item =>
        fetch('/products/' + item.handle + '.json')
          .then(r => r.ok ? r.json() : null)
          .then(data => {
            if (!data || !data.product) return null;
            const p = data.product;
            /* Build image lookup map from images[] */
            const imgMap = {};
            (p.images || []).forEach(img => { imgMap[img.id] = img.src; });
            const defaultImg = (p.image && p.image.src) || (p.images && p.images[0] && p.images[0].src) || '';
            /* If specific variant requested, put it first in the variants list */
            let variants = p.variants.slice();
            if (item.variantId) {
              const idx = variants.findIndex(v => v.id === item.variantId);
              if (idx > 0) {
                const picked = variants.splice(idx, 1)[0];
                variants = [picked].concat(variants);
              }
            }
            return {
              title: p.title,
              handle: p.handle,
              /* .json returns prices as string dollars (e.g. "178.99") */
              variants: variants.map(v => ({
                id: v.id,
                title: v.title,
                price: parseFloat(v.price),
                compare_at_price: v.compare_at_price ? parseFloat(v.compare_at_price) : null,
                image: v.image_id && imgMap[v.image_id] ? imgMap[v.image_id] : defaultImg
              })),
              defaultImage: defaultImg,
              images: [{ src: defaultImg }]
            };
          })
          .catch(() => null)
      );
    } else {
      /* Curated door bundle — 2 accessories (hinge + handle). Trim/baseboard dropped
         Apr 18 — kept install bundle focused on what every interior door needs. */
      const doorBundle = [
        { handle: 'tough-guard-2pc-door-hinge-3in-x-3in-x-2mm-square-corner' },
        { handle: 'tough-guard-door-lock-square-lever' }
      ];
      fetchPromises = doorBundle.map(item =>
        fetch('/products/' + item.handle + '.json')
          .then(r => r.ok ? r.json() : null)
          .then(data => {
            if (!data || !data.product) return null;
            const p = data.product;
            const imgMap = {};
            (p.images || []).forEach(img => { imgMap[img.id] = img.src; });
            const defaultImg = (p.image && p.image.src) || (p.images && p.images[0] && p.images[0].src) || '';
            return {
              title: p.title,
              handle: p.handle,
              variants: p.variants.map(v => ({
                id: v.id,
                title: v.title,
                price: parseFloat(v.price),
                compare_at_price: v.compare_at_price ? parseFloat(v.compare_at_price) : null,
                image: v.image_id && imgMap[v.image_id] ? imgMap[v.image_id] : defaultImg
              })),
              defaultImage: defaultImg,
              images: [{ src: defaultImg }]
            };
          })
          .catch(() => null)
      );
    }

    Promise.all(fetchPromises).then(results => {
      const upsells = results.filter(Boolean);
      if (!upsells.length) { bundleSection.remove(); return; }

      const DISCOUNT = 0.20;
      const fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
      let checkedItems = new Set();
      const checkSvg = '<svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12"><path d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"/></svg>';

      /* Render locked main product at top — NO discount on main item */
      let html = '<div class="pdp__bundle-item pdp__bundle-item--locked pdp__bundle-item--checked" data-vid="' + currentVid + '" data-orig="' + currentPrice + '" data-disc="' + currentPrice.toFixed(2) + '" data-locked="true">' +
        '<div class="pdp__bundle-check">' + checkSvg + '</div>' +
        '<img src="' + currentImg + '" alt="" class="pdp__bundle-img" loading="lazy">' +
        '<div class="pdp__bundle-info"><div class="pdp__bundle-name">' + productData.title + '</div>' +
        '<div class="pdp__bundle-locked-label">This item</div>' +
        '<div class="pdp__bundle-prices"><span class="pdp__bundle-price-now" style="color:#111;">' + fmt.format(currentPrice) + '</span></div></div></div>';

      /* Render upsell items */
      upsells.forEach((p, i) => {
        /* Normalize: vanity bundle uses new shape (variants with price as number + image),
           door bundle uses legacy shape (variants[].price as string, images[0].src) */
        const firstV = p.variants[0];
        // "was" must be compare_at_price (MSRP) to match checkout. Falling back to variant.price
        // when compare_at is null/equal preserves behavior for products without a sale price.
        const salePrice = typeof firstV.price === 'number' ? firstV.price : (parseFloat(firstV.price) || 0);
        const compareAt = typeof firstV.compare_at_price === 'number' ? firstV.compare_at_price : (parseFloat(firstV.compare_at_price) || 0);
        const origPrice = (compareAt > salePrice) ? compareAt : salePrice;
        const discPrice = origPrice * (1 - DISCOUNT);
        const itemSaving = origPrice - discPrice;
        const img = firstV.image || (p.images && p.images[0] && p.images[0].src) || '';
        const vid = firstV.id;
        checkedItems.add(i);

        /* Variant selector (only if >1 variant) */
        let variantPicker = '';
        if (p.variants.length > 1) {
          variantPicker = '<div class="pdp__bundle-variant-wrap"><select class="pdp__bundle-variant-select" data-idx="' + i + '" aria-label="Choose option for ' + p.title + '">';
          p.variants.forEach(v => {
            const vSale = typeof v.price === 'number' ? v.price : (parseFloat(v.price) || 0);
            const vCompareAt = typeof v.compare_at_price === 'number' ? v.compare_at_price : (parseFloat(v.compare_at_price) || 0);
            const vPrice = (vCompareAt > vSale) ? vCompareAt : vSale;
            const vImg = v.image || img;
            variantPicker += '<option value="' + v.id + '" data-price="' + vPrice + '" data-image="' + vImg.replace(/"/g, '&quot;') + '">' + (v.title || 'Default') + '</option>';
          });
          variantPicker += '</select></div>';
        }

        // Per-item qty stepper — hidden when main qty is 1 (one bundle item per main = 1, no stepper needed).
        var qtyStepperHtml =
          '<div class="pdp__bundle-qty" data-bundle-qty-wrap hidden>' +
            '<span class="pdp__bundle-qty-label">Qty:</span>' +
            '<div class="pdp__bundle-qty-stepper">' +
              '<button type="button" class="pdp__bundle-qty-btn" data-bundle-qty="dec" aria-label="Less">−</button>' +
              '<input type="number" class="pdp__bundle-qty-input" data-bundle-qty-input value="1" min="1" max="1">' +
              '<button type="button" class="pdp__bundle-qty-btn" data-bundle-qty="inc" aria-label="More">+</button>' +
            '</div>' +
          '</div>';

        html += '<div class="pdp__bundle-item pdp__bundle-item--checked" data-idx="' + i + '" data-vid="' + vid + '" data-orig="' + origPrice + '" data-disc="' + discPrice.toFixed(2) + '">' +
          '<div class="pdp__bundle-check">' + checkSvg + '</div>' +
          '<a href="/products/' + p.handle + '" class="pdp__bundle-img-link" aria-label="View ' + p.title + '"><img src="' + img + '" alt="" class="pdp__bundle-img" loading="lazy" data-bundle-img></a>' +
          '<div class="pdp__bundle-info"><div class="pdp__bundle-name"><a href="/products/' + p.handle + '" class="pdp__bundle-name-link">' + p.title + '</a></div>' +
          variantPicker +
          '<div class="pdp__bundle-prices"><span class="pdp__bundle-price-now" data-bundle-price-now>' + fmt.format(discPrice) + '</span>' +
          '<span class="pdp__bundle-price-was" data-bundle-price-was>' + fmt.format(origPrice) + '</span>' +
          '<span class="pdp__bundle-item-save" data-bundle-save>Save ' + fmt.format(itemSaving) + '</span></div>' +
          qtyStepperHtml +
          '</div></div>';
      });

      bundleItems.innerHTML = html;
      // After bundle items render, apply current main qty to the new steppers
      if (window.HCS_SYNC_ADDON_QTY) window.HCS_SYNC_ADDON_QTY(parseInt(document.getElementById('pdp-qty')?.value || 1, 10));

      const bundleDiscount = document.getElementById('pdp-bundle-discount');
      const bundleSavingsAmount = document.getElementById('pdp-bundle-savings-amount');
      const bundleAtcSavings = document.getElementById('pdp-bundle-atc-savings');

      function updateTotals() {
        /* Main product at full price — only add-ons get 20% off */
        let origTotal = currentPrice, discTotal = currentPrice;
        bundleItems.querySelectorAll('.pdp__bundle-item--checked:not([data-locked])').forEach(el => {
          origTotal += parseFloat(el.dataset.orig);
          discTotal += parseFloat(el.dataset.disc);
        });
        const totalItems = checkedItems.size + 1; /* +1 for locked main product */
        const savings = origTotal - discTotal;
        bundleWas.textContent = fmt.format(origTotal);
        bundleNow.textContent = fmt.format(discTotal);
        if (bundleDiscount) bundleDiscount.textContent = '-' + fmt.format(savings);
        if (bundleSavingsAmount) bundleSavingsAmount.textContent = 'You save ' + fmt.format(savings) + ' on ' + totalItems + ' item' + (totalItems > 1 ? 's' : '');
        if (bundleAtcSavings) bundleAtcSavings.textContent = 'You save ' + fmt.format(savings);
        bundleFooter.style.display = '';
      }
      updateTotals();

      /* Click handler — only for non-locked items. Ignore clicks on the variant selector,
         any anchor (product image + title link through to the product page), and qty stepper. */
      bundleItems.querySelectorAll('.pdp__bundle-item:not([data-locked])').forEach(item => {
        item.addEventListener('click', function(e) {
          if (e.target.closest('.pdp__bundle-variant-wrap')) return;
          if (e.target.closest('a')) return;
          if (e.target.closest('.pdp__bundle-qty')) return;
          const idx = parseInt(this.dataset.idx);
          if (checkedItems.has(idx)) {
            checkedItems.delete(idx);
            this.classList.remove('pdp__bundle-item--checked');
          } else {
            checkedItems.add(idx);
            this.classList.add('pdp__bundle-item--checked');
          }
          updateTotals();
        });
      });

      /* Variant selector change handler — updates image, price, vid, savings in real time */
      bundleItems.querySelectorAll('.pdp__bundle-variant-select').forEach(sel => {
        sel.addEventListener('click', function(e) { e.stopPropagation(); });
        sel.addEventListener('change', function(e) {
          e.stopPropagation();
          const opt = this.options[this.selectedIndex];
          const newVid = parseInt(opt.value);
          const newPrice = parseFloat(opt.dataset.price);
          const newImage = opt.dataset.image;
          const item = this.closest('.pdp__bundle-item');
          if (!item) return;
          const newDisc = newPrice * (1 - DISCOUNT);
          item.dataset.vid = newVid;
          item.dataset.orig = newPrice;
          item.dataset.disc = newDisc.toFixed(2);
          const imgEl = item.querySelector('[data-bundle-img]');
          if (imgEl && newImage) imgEl.src = newImage;
          const nowEl = item.querySelector('[data-bundle-price-now]');
          const wasEl = item.querySelector('[data-bundle-price-was]');
          const saveEl = item.querySelector('[data-bundle-save]');
          if (nowEl) nowEl.textContent = fmt.format(newDisc);
          if (wasEl) wasEl.textContent = fmt.format(newPrice);
          if (saveEl) saveEl.textContent = 'Save ' + fmt.format(newPrice - newDisc);
          updateTotals();
        });
      });

      if (bundleAtc) {
        bundleAtc.addEventListener('click', function() {
          const items = [];
          /* Read CURRENT variant fresh — initBundle closure captured `currentVid`
             at page load. User may have changed variants since; without this the
             bundle would add the initial variant, not the user's actual selection.
             Also: `_Bundle Parent Variant` uses this live ID so cart-side
             has_bundle check can match per-variant (not per-product).  */
          const liveVid = parseInt(document.getElementById('pdp-variant-id')?.value, 10) || currentVid;
          const bundleParent = productData.title;
          const bundleParentId = String(productData.id || '');
          const childProps = {
            '_Bundle Parent': bundleParent,
            '_Bundle Parent ID': bundleParentId,
            '_Bundle Parent Variant': String(liveVid),
            '_bundle_discount': '20%'
          };
          /* Main vanity — NO bundle props, acts as parent. Use the main qty input value. */
          const mainBundleQty = parseInt(document.getElementById('pdp-qty')?.value || 1, 10) || 1;
          items.push({ id: liveVid, quantity: mainBundleQty });
          /* Child add-ons — tagged for nesting under parent.
             Each child uses its own qty input (defaults to main qty, capped at main qty). */
          bundleItems.querySelectorAll('.pdp__bundle-item--checked:not([data-locked])').forEach(el => {
            const childQtyInput = el.querySelector('[data-bundle-qty-input]');
            const childQty = Math.max(1, Math.min(mainBundleQty, parseInt(childQtyInput?.value || mainBundleQty, 10) || mainBundleQty));
            items.push({ id: parseInt(el.dataset.vid), quantity: childQty, properties: childProps });
          });
          /* If protection plan checkbox is checked, include the plan(s) in the bundle ATC.
             Plan qty defaults to main qty (one plan per vanity), user-overridable via stepper.
             Read state via window.HCS_PROTECT_STATE — initProtectionPlan IIFE owns the closures
             for selectedPlan + tier; this getter is exposed there. */
          const protectCheckbox = document.getElementById('pdp-protect-check');
          const protState = (typeof window.HCS_PROTECT_STATE === 'function') ? window.HCS_PROTECT_STATE() : null;
          if (protectCheckbox?.checked && protState && protState.tier) {
            const planVariantId = protState.selectedPlan === '5yr' ? protState.tier.y5vid : protState.tier.y3vid;
            const planYears = protState.selectedPlan === '5yr' ? 5 : 3;
            const protectQtyInput = document.getElementById('pdp-protect-qty');
            const planQty = Math.max(1, Math.min(mainBundleQty, parseInt(protectQtyInput?.value || mainBundleQty, 10) || mainBundleQty));
            items.push({
              id: planVariantId,
              quantity: planQty,
              properties: { '_Protected Product': bundleParent, '_Protected Variant': String(liveVid), '_Plan Term': planYears + ' Year' }
            });
          }
          this.textContent = 'Adding...';
          this.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(r => r.json().then(d => ({ ok: r.ok, status: r.status, body: d }))).then(({ ok, status, body }) => {
            if (!ok) {
              console.error('Bundle ATC failed', status, body);
              const msg = (body && body.description) || (body && body.message) || ('HTTP ' + status);
              this.innerHTML = '<span>Add Bundle to Cart</span>';
              this.disabled = false;
              alert('Could not add bundle: ' + msg);
              return;
            }
            const data = body;
            this.innerHTML = '<span>Added to Cart! ✓</span>';
            /* Uncheck PP checkbox so next variant ATC doesn't carry over stale selection */
            const ppCb = document.getElementById('pdp-protect-check');
            if (ppCb) ppCb.checked = false;
            /* Open mini-cart drawer with nesting (defined in custom-header.liquid). */
            if (window.HCS_OPEN_ATC_DRAWER) window.HCS_OPEN_ATC_DRAWER(data);
            /* Fire cart events so badges + listeners update */
            fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).then(cart => {
              document.querySelectorAll('[data-cart-count], .cart-count, #cart-count').forEach(el => { el.textContent = cart.item_count; });
              const detail = { resource: cart, sourceId: 'pdp-bundle', data: { source: 'pdp-bundle', itemCount: cart.item_count } };
              document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: detail }));
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            });
            setTimeout(() => {
              this.innerHTML = '<span>Add Bundle to Cart</span><span class="pdp__bundle-atc-savings" id="pdp-bundle-atc-savings"></span>';
              this.disabled = false;
              updateTotals();
            }, 2000);
          }).catch((err) => {
            console.error('Bundle ATC failed:', err);
            this.innerHTML = '<span>Add Bundle to Cart</span>';
            this.disabled = false;
            alert('Could not add bundle to cart. Please try again.');
          });
        });
      }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initBundle); } else { initBundle(); }

  /* ===== STICKY NAV ===== */
  const stickyNav = document.getElementById('pdp-sticky-nav');
  const split = document.getElementById('pdp-split');
  if (stickyNav && split) {
    const observer = new IntersectionObserver(([e]) => {
      stickyNav.classList.toggle('pdp__sticky--show', !e.isIntersecting);
    }, { threshold: 0 });
    observer.observe(split);
  }
  const stickyAtcBtn = document.getElementById('pdp-sticky-atc-btn');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', () => {
      const form = document.getElementById('pdp-form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ===== STICKY NAV LINKS — no tabs, Rona-style ===== */

  /* ===== HIDE all third-party "bought together" app widgets =====
     Matches any section whose heading starts with "Products customers bought together",
     "Frequently bought together", "Buy it with", "Complete the look", etc. */
  var BT_PATTERNS = [
    /^products?\s+customers?\s+bought\s+together/i,
    /^frequently\s+bought\s+together/i,
    /^customers?\s+who\s+bought/i,
    /^(complete|perfect)\s+the\s+(look|bundle)/i,
    /^buy\s+it\s+(with|together)/i,
    /^bundle\s+and\s+save/i,
    /^get\s+the\s+set/i
  ];
  function isBoughtTogetherHeading(text) {
    if (!text) return false;
    var t = text.trim().replace(/\s+/g, ' ').slice(0, 80);
    return BT_PATTERNS.some(function(r){ return r.test(t); });
  }
  function hideThirdPartyBundle() {
    /* Check shopify-section wrappers + .section + sections/app blocks */
    var candidates = document.querySelectorAll('.shopify-section, [id^="shopify-section-"], [id^="shopify-block-"], section, div');
    candidates.forEach(function(el){
      if (el.dataset.hcsBtChecked === 'done') return;
      /* skip our own pdp__bundle */
      if (el.id === 'pdp-bundle' || el.closest('#pdp-bundle')) return;
      /* find heading element inside */
      var heading = el.querySelector('h1, h2, h3, h4, [class*="heading"], [class*="title"]');
      var textSource = heading ? heading.textContent : el.textContent;
      if (isBoughtTogetherHeading(textSource) && el.offsetHeight > 80) {
        el.style.setProperty('display', 'none', 'important');
        el.dataset.hcsBtChecked = 'done';
      }
    });
  }
  hideThirdPartyBundle();
  setTimeout(hideThirdPartyBundle, 500);
  setTimeout(hideThirdPartyBundle, 1500);
  setTimeout(hideThirdPartyBundle, 3500);
  /* Late-insertion watcher — many apps render 3-8s after DOMContentLoaded */
  var btObs = new MutationObserver(function(){ hideThirdPartyBundle(); });
  btObs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function(){ btObs.disconnect(); }, 15000);

  /* ===== PARSE DIMENSIONS ===== */
  const desc = productData.description || '';
  const dimSection = document.getElementById('pdp-dimensions');
  const dimValues = document.getElementById('pdp-dim-values');
  if (dimSection && dimValues) {
    const dimMatch = desc.match(/(?:Main\s*Cabinet|Cabinet|Vanity)[:\s]*([^<\n]+)/i);
    if (dimMatch) {
      const raw = dimMatch[1];
      const wMatch = raw.match(/([\d\s\/]+)[″"]\s*W/);
      const hMatch = raw.match(/([\d\s\/]+)[″"]\s*H/);
      const dMatch = raw.match(/([\d\s\/]+)[″"]\s*D/);
      let html = '';
      if (wMatch) html += '<div class="pdp__dim-card"><span class="pdp__dim-val">'+wMatch[1].trim()+'"</span><span class="pdp__dim-label">Width</span></div>';
      if (hMatch) html += '<div class="pdp__dim-card"><span class="pdp__dim-val">'+hMatch[1].trim()+'"</span><span class="pdp__dim-label">Height</span></div>';
      if (dMatch) html += '<div class="pdp__dim-card"><span class="pdp__dim-val">'+dMatch[1].trim()+'"</span><span class="pdp__dim-label">Depth</span></div>';
      if (html) { dimValues.innerHTML = html; dimSection.style.display = ''; }
    }
  }

  /* ===== SIMILAR ITEMS — Strict same-collection best-sellers =====
     Pulls best-sellers from the SAME specific collection as the current product.
     Excludes broad catch-all collections ("all", "sale", "bath-products", etc.).
     Works for every product type: faucets → faucets only, vanities → vanities only, etc. */
  function initSimilarItems() {
    const track = document.getElementById('pdp-similar-track');
    const section = document.getElementById('pdp-similar');
    const pid = String(window.meta?.product?.id || productData.id || '');
    if (!track || !section) return;

    const title = productData.title || '';
    const handles = productData.collectionHandles || [];
    const currentType = (productData.type || '').toLowerCase();
    const fmt = new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'});

    /* 1. Find the MOST SPECIFIC collection — exclude broad catch-all handles */
    const BROAD = /^(all|all-products|sale|on-sale|new|featured|bestsellers|best-sellers|bath|bath-products|all-bath-products|kitchen|vanities-faucets-and-showers|bathroom|home|trending|clearance)/;
    const specificHandles = handles.filter(h => !BROAD.test(h));
    let collHandle = specificHandles[0] || handles[0] || '';

    if (!collHandle) { section.remove(); return; }

    /* 2. Fetch collection products — Shopify returns in collection's configured sort order.
       For best-selling results, ensure the collection's admin sort is set to "Best Selling". */
    fetch('/collections/' + collHandle + '/products.json?limit=50')
      .then(r => r.json())
      .then(data => {
        let products = (data.products || []).filter(p => String(p.id) !== pid && p.available !== false);

        /* 3. Strict type filter — only include products matching current product_type */
        if (currentType) {
          const sameType = products.filter(p => (p.product_type || '').toLowerCase() === currentType);
          /* Use strict filter ONLY if we have enough matches; otherwise use whole collection */
          if (sameType.length >= 4) products = sameType;
        }

        /* 4. Size preference — if current product has a size (e.g. 36", 42"), prefer same size first */
        const sizeMatch = title.match(/(\d+)\s*["″']/);
        const currentSize = sizeMatch ? parseInt(sizeMatch[1]) : null;
        if (currentSize) {
          const getSize = (t) => {
            const m = String(t).match(/(\d+)\s*["″']/);
            return m ? parseInt(m[1]) : null;
          };
          products.sort((a, b) => {
            const aSize = getSize(a.title), bSize = getSize(b.title);
            const aDiff = aSize !== null ? Math.abs(aSize - currentSize) : 999;
            const bDiff = bSize !== null ? Math.abs(bSize - currentSize) : 999;
            return aDiff - bDiff;
          });
        }
        /* Otherwise keep Shopify's collection order (best-selling if admin configured) */

        /* 5. Take top 6 — popular in positions 1-3 where eye lands first */
        const results = products.slice(0, 6);
        if (!results.length) { section.remove(); return; }

        renderSimilarCards(track, results, false, fmt, pid);
      })
      .catch(() => section.remove());
  }

  /* Shared card renderer for similar items
     isCents=true  → Recommendations API (prices in cents)
     isCents=false → Collection API (prices in dollars as strings) */
  function renderSimilarCards(track, products, isCents, fmt, pid) {
    var section = track.closest('.pdp__section--js');
    track.innerHTML = products.filter(p => String(p.id) !== String(pid)).map(p => {
      const img = p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : (p.featured_image || '');
      const imgSrc = typeof img === 'string' ? img : img.src || '';
      let curPrice, compPrice;
      if (isCents) {
        curPrice = (p.price || 0) / 100;
        compPrice = (p.compare_at_price || 0) / 100;
      } else {
        curPrice = parseFloat(p.variants ? p.variants[0].price : p.price) || 0;
        compPrice = parseFloat(p.variants ? p.variants[0].compare_at_price : 0) || 0;
      }
      const onSale = compPrice > curPrice;
      const url = p.url || ('/products/'+p.handle);
      let priceHtml = onSale
        ? '<div class="pdp__card-price pdp__card-price--sale">'+fmt.format(curPrice)+'<span class="pdp__card-compare">'+fmt.format(compPrice)+'</span></div>'
        : '<div class="pdp__card-price">'+fmt.format(curPrice)+'</div>';
      return '<a href="'+url+'" class="pdp__card"><img src="'+imgSrc+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" loading="lazy"><div class="pdp__card-body"><div class="pdp__card-title">'+p.title+'</div>'+priceHtml+'<span class="pdp__card-cta">View Product →</span></div></a>';
    }).join('');
    if (track.innerHTML && section) section.style.display = '';
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initSimilarItems); } else { initSimilarItems(); }

  /* ===== COMPLETE YOUR PROJECT (category-based recommendations) ===== */
  function initCompleteProject() {
    const tabs = document.getElementById('pdp-cat-tabs');
    const track = document.getElementById('pdp-complete-track');
    if (!tabs || !track) return;
    const colls = productData.collections || [];
    const tgs = productData.tags || [];
    const tp = (productData.type || '').toLowerCase();
    let cats = [];

    if (tp.includes('vanit') || tgs.some(t => t.toLowerCase().includes('vanit')) || colls.some(c => c.toLowerCase().includes('vanit'))) {
      cats = [
        { name: 'Faucets', handle: 'faucets' },
        { name: 'Mirrors', handle: 'mirrors' },
        { name: 'Countertops', handle: 'countertops' },
        { name: 'Shower', handle: 'shower' },
        { name: 'Toilets', handle: 'toilets' },
        { name: 'Drains', handle: 'drains' }
      ];
    } else if (tp.includes('door') || tgs.some(t => t.toLowerCase().includes('door')) || colls.some(c => c.toLowerCase().includes('door'))) {
      cats = [
        { name: 'Baseboards', handle: 'baseboards' },
        { name: 'Door Hinges', handle: 'door-hinges' },
        { name: 'Casings', handle: 'casings' },
        { name: 'Trim & Mouldings', handle: 'trim-mouldings' }
      ];
    }

    if (!cats.length) { document.getElementById('pdp-complete')?.remove(); return; }

    tabs.innerHTML = cats.map((c,i) =>
      '<button class="pdp__cat-tab'+(i===0?' pdp__cat-tab--on':'')+'" data-handle="'+c.handle+'">'+c.name+'</button>'
    ).join('');

    function loadColl(handle) {
      fetch('/collections/'+handle+'/products.json?limit=8')
        .then(r=>r.json())
        .then(data => {
          if (!data.products || !data.products.length) { track.innerHTML = '<p style="color:#666;text-align:center;padding:20px;">No products found in this category.</p>'; return; }
          const fmt = new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'});
          track.innerHTML = data.products.map(p => {
            const img = p.images && p.images[0] ? p.images[0].src : '';
            const curPrice = parseFloat(p.variants[0].price) || 0;
            const compPrice = parseFloat(p.variants[0].compare_at_price) || 0;
            const onSale = compPrice > curPrice;
            let priceHtml = onSale
              ? '<div class="pdp__card-price pdp__card-price--sale">'+fmt.format(curPrice)+'<span class="pdp__card-compare">'+fmt.format(compPrice)+'</span></div>'
              : '<div class="pdp__card-price">'+fmt.format(curPrice)+'</div>';
            return '<a href="/products/'+p.handle+'" class="pdp__card"><img src="'+img+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" loading="lazy"><div class="pdp__card-body"><div class="pdp__card-title">'+p.title+'</div>'+priceHtml+'<span class="pdp__card-cta">View Product →</span></div></a>';
          }).join('');
          document.getElementById('pdp-complete').style.display = '';
        }).catch(()=>{ track.innerHTML = ''; });
    }

    loadColl(cats[0].handle);
    tabs.addEventListener('click', function(e){
      const tab = e.target.closest('.pdp__cat-tab');
      if (!tab) return;
      tabs.querySelectorAll('.pdp__cat-tab').forEach(t=>t.classList.remove('pdp__cat-tab--on'));
      tab.classList.add('pdp__cat-tab--on');
      loadColl(tab.dataset.handle);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initCompleteProject); } else { initCompleteProject(); }

  /* ===== COMPARE PRODUCTS — Smart size-matched, best-selling ===== */
  function initCompare() {
    const head = document.getElementById('pdp-compare-head');
    const body = document.getElementById('pdp-compare-body');
    const section = document.getElementById('pdp-compare');
    const pid = window.meta?.product?.id || productData.id;
    const title = productData.title || '';
    if (!head || !body || !section || !pid) { section?.remove(); return; }

    /* 1. Parse vanity size from title (e.g. "36" from "Tesoro 36" Shaker...") */
    const sizeMatch = title.match(/(\d{2,3})[""″\s]*(?:inch|in\b|"|″)?/i);
    const size = sizeMatch ? parseInt(sizeMatch[1]) : 0;

    /* 2. Map size to collection handle (best-selling sort) */
    let collHandle = '';
    if (size <= 29) collHandle = '24-and-under';
    else if (size <= 39) collHandle = '30-to-36';
    else if (size <= 49) collHandle = '40-to-48';
    else if (size <= 69) collHandle = '54-to-64';
    else if (size >= 70) collHandle = '70-to-over';

    /* Use recommendations API (works for all product types reliably) */
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
      .then(r => r.json())
      .then(data => {
        var products = (data.products || []).filter(function(p){ return String(p.id) !== String(pid) && p.price > 0; }).slice(0, 4);
        if (products.length < 2) { section.remove(); return; }

        /* Update title if vanity with size */
        var allColls = (productData.collections || []).map(c => c.toLowerCase()).join(' ');
        var isVanity = allColls.includes('vanit') || title.toLowerCase().includes('vanit');
        if (isVanity && size) {
          var titleEl = document.querySelector('#pdp-compare .pdp__section-title');
          if (titleEl) titleEl.textContent = 'Compare ' + size + '\u2033 Vanities';
        }

        renderCompare(products, true);
      })
      .catch(() => section.remove());

    function renderCompare(items, isCents) {
      const fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2 });
      const currentImg = document.querySelector('.pdp__img')?.src || '';
      const currentPriceRaw = parseFloat(document.getElementById('pdp-price')?.textContent?.replace(/[^0-9.]/g,'')) || 0;
      const currentVendor = productData.vendor || '';

      function fmtPrice(p) {
        const str = fmt.format(p);
        const parts = str.split('.');
        return parts[0] + '.<sup>' + (parts[1] || '00') + '</sup>';
      }

      function boldVendor(titleStr, vendor) {
        if (!vendor) return titleStr;
        const idx = titleStr.toLowerCase().indexOf(vendor.toLowerCase());
        if (idx === 0) return '<strong>' + titleStr.substring(0, vendor.length) + '</strong>' + titleStr.substring(vendor.length);
        return titleStr;
      }

      /* Helper: detect material from title/tags */
      function getMaterial(p) {
        const t = (p.title || '').toLowerCase() + ' ' + ((p.tags || []).join(' ')).toLowerCase();
        if (t.includes('quartz')) return 'Quartz';
        if (t.includes('marble')) return 'Marble';
        if (t.includes('ceramic')) return 'Ceramic';
        if (t.includes('granite')) return 'Granite';
        if (t.includes('porcelain')) return 'Porcelain';
        return '-';
      }

      /* Helper: detect sink type */
      function getSinkType(p) {
        const t = (p.title || '').toLowerCase();
        if (t.includes('double sink') || t.includes('double-sink')) return 'Double sink';
        if (t.includes('single sink') || t.includes('single-sink')) return 'Single sink';
        return 'Single sink';
      }

      /* ── Build all prices to find "Best Price" ── */
      const allPrices = [currentPriceRaw];
      items.forEach(p => {
        const raw = parseFloat(p.variants[0].price) || 0;
        allPrices.push(isCents ? raw / 100 : raw);
      });
      const lowestPrice = Math.min.apply(null, allPrices.filter(p => p > 0));

      /* Header: product cards with images + names */
      head.innerHTML = '<tr><th></th>' +
        '<th class="pdp__compare-current"><div class="pdp__compare-header-content"><span class="pdp__compare-badge">Current Item</span><img src="' + currentImg + '" class="pdp__compare-img" alt=""><span class="pdp__compare-name">' + boldVendor(title.substring(0, 65), currentVendor) + '</span></div></th>' +
        items.map(p => {
          const img = p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : '';
          return '<th><div class="pdp__compare-header-content"><img src="' + img + '" class="pdp__compare-img" alt=""><span class="pdp__compare-name">' + boldVendor(p.title.substring(0, 65), p.vendor) + '</span><a href="/products/' + p.handle + '" class="pdp__compare-link">View Details</a></div></th>';
        }).join('') + '</tr>';

      /* Data rows with section dividers */
      let rows = '';
      const colCount = items.length + 2;

      /* ── SECTION: PRICING ── */
      rows += '<tr class="pdp__compare-divider"><td colspan="' + colCount + '">Pricing</td></tr>';

      /* Price with best-price badge */
      rows += '<tr><td>Price</td><td class="pdp__compare-current"><div class="pdp__compare-price-cell"><span class="pdp__compare-price">' + fmtPrice(currentPriceRaw) + '</span>';
      if (allPrices.length > 2 && currentPriceRaw === lowestPrice) rows += '<span class="pdp__compare-best">Best Price</span>';
      rows += '</div></td>';
      items.forEach(p => {
        const rawPrice = parseFloat(p.variants[0].price) || 0;
        const price = isCents ? rawPrice / 100 : rawPrice;
        const compare = p.variants[0].compare_at_price ? parseFloat(p.variants[0].compare_at_price) : 0;
        const comparePrice = isCents ? compare / 100 : compare;
        rows += '<td><div class="pdp__compare-price-cell"><span class="pdp__compare-price">' + fmtPrice(price) + '</span>';
        if (comparePrice > price) {
          const savePct = Math.round((1 - price/comparePrice) * 100);
          rows += '<span class="pdp__compare-was">' + fmt.format(comparePrice) + '</span><span class="pdp__compare-save">Save ' + savePct + '%</span>';
        }
        if (allPrices.length > 2 && price === lowestPrice) rows += '<span class="pdp__compare-best">Best Price</span>';
        rows += '</div></td>';
      });
      rows += '</tr>';

      /* Brand */
      rows += '<tr><td>Brand</td><td class="pdp__compare-current"><strong>' + currentVendor + '</strong></td>';
      items.forEach(p => { rows += '<td>' + (p.vendor || '<span class="pdp__compare-x">—</span>') + '</td>'; });
      rows += '</tr>';

      /* ── SECTION: SPECIFICATIONS ── */
      rows += '<tr class="pdp__compare-divider"><td colspan="' + colCount + '">Specifications</td></tr>';

      /* Size */
      rows += '<tr><td>Width</td><td class="pdp__compare-current">' + (size ? '<strong>' + size + '″</strong>' : '<span class="pdp__compare-x">—</span>') + '</td>';
      items.forEach(p => {
        const m = p.title.match(/(\d{2,3})[""″\s]*(?:inch|in\b|"|″)?/i);
        rows += '<td>' + (m ? '<strong>' + m[1] + '″</strong>' : '<span class="pdp__compare-x">—</span>') + '</td>';
      });
      rows += '</tr>';

      /* Sink Type */
      rows += '<tr><td>Sink Type</td><td class="pdp__compare-current">' + getSinkType(productData) + '</td>';
      items.forEach(p => { rows += '<td>' + getSinkType(p) + '</td>'; });
      rows += '</tr>';

      /* Top Material */
      rows += '<tr><td>Countertop</td><td class="pdp__compare-current">' + getMaterial(productData) + '</td>';
      items.forEach(p => { rows += '<td>' + getMaterial(p) + '</td>'; });
      rows += '</tr>';

      /* Colors / Options */
      rows += '<tr><td>Finishes</td><td class="pdp__compare-current">' + (variants.length > 1 ? '<strong>' + variants.length + '</strong> options' : '1 option') + '</td>';
      items.forEach(p => {
        const ct = p.variants ? p.variants.length : 0;
        rows += '<td>' + (ct > 1 ? '<strong>' + ct + '</strong> options' : '1 option') + '</td>';
      });
      rows += '</tr>';

      /* Assembly */
      const currentAssembly = title.toLowerCase().includes('assemble') || (productData.body_html || '').toLowerCase().includes('assembled') ? '<span class="pdp__compare-check">&#10003; Pre-assembled</span>' : '<span class="pdp__compare-x">—</span>';
      rows += '<tr><td>Assembly</td><td class="pdp__compare-current">' + currentAssembly + '</td>';
      items.forEach(p => {
        const assembled = (p.title + ' ' + (p.body_html || '')).toLowerCase().includes('assembl');
        rows += '<td>' + (assembled ? '<span class="pdp__compare-check">&#10003; Pre-assembled</span>' : '<span class="pdp__compare-x">—</span>') + '</td>';
      });
      rows += '</tr>';

      /* ── SECTION: AVAILABILITY ── */
      rows += '<tr class="pdp__compare-divider"><td colspan="' + colCount + '">Availability</td></tr>';

      /* In Stock */
      rows += '<tr><td>In Stock</td><td class="pdp__compare-current"><span class="pdp__compare-check">&#10003; In stock</span></td>';
      items.forEach(p => {
        rows += '<td>' + (p.available !== false ? '<span class="pdp__compare-check">&#10003; In stock</span>' : '<span class="pdp__compare-x">Unavailable</span>') + '</td>';
      });
      rows += '</tr>';

      /* Shipping — per-product vanity check. Vanity + GTA = FREE. Non-vanity = calculated at checkout. */
      var currentIsVanity = /vanit/i.test(title) || (productData.type || '').toLowerCase().indexOf('vanit') !== -1 || (productData.tags || []).some(function(t){ return /vanit/i.test(t); });
      rows += '<tr class="pdp__compare-shipping-row"><td>Shipping</td>';
      rows += '<td class="pdp__compare-current" data-pdp-ship-cell data-vanity="' + (currentIsVanity ? '1' : '0') + '"></td>';
      items.forEach(function(p){
        var isV = /vanit/i.test(p.title || '') || ((p.product_type || '').toLowerCase().indexOf('vanit') !== -1) || ((p.tags || []).some(function(t){ return /vanit/i.test(t); }));
        rows += '<td data-pdp-ship-cell data-vanity="' + (isV ? '1' : '0') + '"></td>';
      });
      rows += '</tr>';

      body.innerHTML = rows;
      section.style.display = '';
      updateCompareShipping();
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initCompare); } else { initCompare(); }

  /* Per-product shipping text — vanity + GTA = FREE Shipping, otherwise calculated at checkout */
  function updateCompareShipping() {
    /* Central resolver: postal-based truth. Fall back to body class if helper unavailable. */
    var isGTA;
    if (window.HCS_SHIPPING && typeof window.HCS_SHIPPING.isGTA === 'function') {
      isGTA = window.HCS_SHIPPING.isGTA() === true;
    } else {
      isGTA = document.body.classList.contains('hcs-gta-detected');
    }
    document.querySelectorAll('[data-pdp-ship-cell]').forEach(function(cell){
      var isVanity = cell.dataset.vanity === '1';
      if (isVanity && isGTA) {
        cell.innerHTML = '<span class="pdp__compare-check">FREE Shipping</span>';
      } else {
        cell.innerHTML = '<span style="color:#666;font-size:12px;">Rate calculated at checkout</span>';
      }
    });
  }
  setTimeout(updateCompareShipping, 500);
  setTimeout(updateCompareShipping, 2000);
  setTimeout(updateCompareShipping, 5000);
  /* Cross-tab + geo-event sync — re-render when postal changes or geo detected */
  window.addEventListener('storage', function(e){
    if (e.key === 'hcs_m_postal' || e.key === 'hcs_location' || e.key === 'hcs_detected_city') updateCompareShipping();
  });
  document.addEventListener('hcs:geo-updated', updateCompareShipping);

  /* ===== MORE TO EXPLORE — Smart: Also Viewed (related) vs Ultimately Bought (best-selling same category) ===== */
  function initExplore() {
    const track = document.getElementById('pdp-explore-track');
    const tabs = document.querySelectorAll('.pdp__explore-tab');
    const pid = window.meta?.product?.id;
    const title = productData.title || '';
    if (!track || !pid) { document.getElementById('pdp-explore')?.remove(); return; }

    const fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
    const cache = {};

    /* Detect product category + size for "Ultimately Bought" */
    const allColls = (productData.collections || []).map(c => c.toLowerCase()).join(' ');
    const isVanity = allColls.includes('vanit') || title.toLowerCase().includes('vanit');
    const isDoor = allColls.includes('door') || title.toLowerCase().includes('door');

    /* Map to best-selling collection for "Ultimately Bought" */
    let boughtCollection = '';
    if (isVanity) boughtCollection = 'vanities';
    else if (isDoor) boughtCollection = 'doors';
    else boughtCollection = '';

    function renderCards(products, isCents) {
      if (!products || !products.length) {
        track.innerHTML = '';
        return;
      }
      document.getElementById('pdp-explore').style.display = '';
      track.innerHTML = products.map(p => {
        const img = p.featured_image || (p.images && p.images[0]) || '';
        const imgSrc = typeof img === 'string' ? img : (img.src || '');
        const rawPrice = parseFloat(p.variants ? p.variants[0].price : p.price) || 0;
        const curPrice = isCents ? rawPrice / 100 : rawPrice;
        const rawComp = parseFloat(p.variants ? p.variants[0].compare_at_price : p.compare_at_price) || 0;
        const compPrice = isCents ? rawComp / 100 : rawComp;
        const onSale = compPrice > curPrice;
        const vid = p.variants ? p.variants[0].id : (p.id || 0);
        const url = p.url || ('/products/' + p.handle);
        const priceHtml = onSale
          ? '<div class="pdp__card-price pdp__card-price--sale">'+fmt.format(curPrice)+'<span class="pdp__card-compare">'+fmt.format(compPrice)+'</span></div>'
          : '<div class="pdp__card-price">'+fmt.format(curPrice)+'</div>';
        return '<div class="pdp__card">' +
          '<a href="' + url + '"><img src="' + imgSrc + '" alt="' + (p.title||'').replace(/"/g,'&quot;') + '" loading="lazy"></a>' +
          '<div class="pdp__card-body">' +
          '<a href="' + url + '" class="pdp__card-title">' + p.title + '</a>' +
          priceHtml +
          '<button class="pdp__card-atc" data-vid="' + vid + '">Add to Cart</button>' +
          '</div></div>';
      }).join('');
    }

    function loadAlsoViewed() {
      if (cache.viewed) { renderCards(cache.viewed, true); return; }
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
        .then(r => r.json())
        .then(data => {
          const products = (data.products || []).filter(p => String(p.id) !== String(pid) && p.price > 0);
          cache.viewed = products;
          renderCards(products, true);
        }).catch(() => { track.innerHTML = ''; });
    }

    function loadUltimatelyBought() {
      if (cache.bought) { renderCards(cache.bought, false); return; }
      if (!boughtCollection) {
        /* Fallback: use recommendations with different seed */
        fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
          .then(r => r.json())
          .then(data => {
            const products = (data.products || []).reverse().filter(p => String(p.id) !== String(pid) && p.price > 0);
            cache.bought = products;
            renderCards(products, true);
          }).catch(() => {});
        return;
      }
      /* Fetch best-selling from category collection — these are what customers actually buy */
      fetch('/collections/' + boughtCollection + '/products.json?sort_by=best-selling&limit=12')
        .then(r => r.json())
        .then(data => {
          const products = (data.products || []).filter(p => String(p.id) !== String(pid)).slice(0, 10);
          cache.bought = products;
          renderCards(products, false);
        }).catch(() => { track.innerHTML = ''; });
    }

    /* Load default tab */
    loadAlsoViewed();

    /* Tab switching */
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        tabs.forEach(t => t.classList.remove('pdp__explore-tab--on'));
        this.classList.add('pdp__explore-tab--on');
        if (this.dataset.explore === 'bought') {
          loadUltimatelyBought();
        } else {
          loadAlsoViewed();
        }
      });
    });

    /* Subtle ATC on product cards */
    track.addEventListener('click', function(e) {
      const btn = e.target.closest('.pdp__card-atc');
      if (!btn) return;
      e.preventDefault();
      const vid = btn.dataset.vid;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
      }).then(() => {
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = 'Add to Cart'; }, 2000);
      }).catch(() => { btn.textContent = 'Add to Cart'; });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initExplore); } else { initExplore(); }

  /* ===== RELATED SEARCHES (expanded — 8-10 pills) ===== */
  const relatedPills = document.getElementById('pdp-related-pills');
  if (relatedPills) {
    const colls = productData.collectionUrls || [];
    const collNames = productData.collections || [];
    let pills = [];
    for (let i = 0; i < Math.min(colls.length, 8); i++) {
      pills.push('<a href="' + colls[i] + '" class="pdp__search-pill">' + collNames[i] + '</a>');
    }
    /* Add extra contextual pills */
    const tp = (productData.type || '').toLowerCase();
    const allColls = (productData.collections || []).map(c => c.toLowerCase()).join(' ');
    if (tp.includes('vanit') || allColls.includes('vanit')) {
      pills.push('<a href="/collections/vanities" class="pdp__search-pill">All Vanities</a>');
      pills.push('<a href="/collections/floating-vanity" class="pdp__search-pill">Floating Vanities</a>');
      pills.push('<a href="/collections/faucets" class="pdp__search-pill">Bathroom Faucets</a>');
      pills.push('<a href="/collections/mirrors" class="pdp__search-pill">Mirrors</a>');
      pills.push('<a href="/collections/countertops" class="pdp__search-pill">Countertops</a>');
    } else if (tp.includes('door') || allColls.includes('door')) {
      pills.push('<a href="/collections/doors" class="pdp__search-pill">All Doors</a>');
      pills.push('<a href="/collections/solid-core-doors" class="pdp__search-pill">Solid Core Doors</a>');
      pills.push('<a href="/collections/glass-doors" class="pdp__search-pill">Glass Doors</a>');
      pills.push('<a href="/collections/barn-doors" class="pdp__search-pill">Barn Doors</a>');
      pills.push('<a href="/collections/trim-mouldings" class="pdp__search-pill">Trim & Mouldings</a>');
    }
    /* Deduplicate */
    const seen = new Set();
    const unique = pills.filter(p => {
      const text = p.replace(/<[^>]+>/g, '').trim();
      if (seen.has(text)) return false;
      seen.add(text);
      return true;
    });
    if (unique.length) {
      relatedPills.innerHTML = unique.slice(0, 10).join('');
      document.getElementById('pdp-related').style.display = '';
    }
  }

  /* ===== CAROUSEL ARROWS ===== */
  document.querySelectorAll('.pdp__carousel-arrow').forEach(btn => {
    btn.addEventListener('click', function(){
      const carousel = this.dataset.carousel;
      const track = document.getElementById('pdp-'+carousel+'-track');
      if (!track) return;
      const scrollAmt = 220;
      track.scrollBy({ left: this.dataset.dir === 'next' ? scrollAmt : -scrollAmt, behavior: 'smooth' });
    });
  });

  /* ===== VIEWER COUNT ANIMATION ===== */
  const viewerEl = document.getElementById('pdp-viewers');
  if (viewerEl) {
    const base = parseInt(viewerEl.textContent);
    setInterval(()=>{
      const c = Math.random()>.5?1:-1;
      viewerEl.textContent = Math.max(3,Math.min(base+10,parseInt(viewerEl.textContent)+c));
    },8000);
  }

  /* ===== IMAGE LIGHTBOX ===== */
  function initLightbox() {
    const lightbox = document.getElementById('pdp-lightbox');
    const lbImg = document.getElementById('pdp-lb-img');
    const lbCounter = document.getElementById('pdp-lb-counter');
    if (!lightbox || !lbImg) return;

    /* Use full media list (includes images beyond visible 6) */
    let images = [];
    try { images = JSON.parse(document.getElementById('pdp-all-media')?.textContent || '[]'); } catch(e){}
    if (!images.length) {
      /* Fallback: use visible images */
      document.querySelectorAll('.pdp__img').forEach(img => {
        const src = img.src.replace(/(_\d+x\d*|\d+x)\./, '.');
        images.push(src.includes('?') ? src.replace(/width=\d+/, 'width=1200') : src);
      });
    }
    if (!images.length) return;

    let current = 0;
    function show(idx) {
      current = (idx + images.length) % images.length;
      lbImg.src = images[current];
      lbCounter.textContent = (current + 1) + ' / ' + images.length;
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    function hide() {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.pdp__img').forEach((img, i) => {
      img.addEventListener('click', () => show(i));
    });
    lightbox.querySelector('.pdp__lb-close').addEventListener('click', hide);
    lightbox.querySelector('.pdp__lb-overlay').addEventListener('click', hide);
    lightbox.querySelector('.pdp__lb-arrow--prev').addEventListener('click', () => show(current - 1));
    lightbox.querySelector('.pdp__lb-arrow--next').addEventListener('click', () => show(current + 1));
    document.addEventListener('keydown', e => {
      if (lightbox.style.display === 'none') return;
      if (e.key === 'Escape') hide();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initLightbox); } else { initLightbox(); }

  /* ===== RECENTLY VIEWED ===== */
  function initRecentlyViewed() {
    const KEY = 'hcs_recently_viewed';
    const MAX = 12;
    const pid = window.meta?.product?.id;
    if (!pid) return;

    /* Save current product */
    let viewed = [];
    try { viewed = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) {}
    viewed = viewed.filter(p => p.id !== pid);
    viewed.unshift({
      id: pid,
      title: productData.title || '',
      handle: productData.handle || '',
      url: productData.url || window.location.pathname,
      image: productData.featured_image || (productData.images && productData.images[0]) || '',
      price: productData.price || 0,
      t: Date.now()
    });
    if (viewed.length > MAX) viewed = viewed.slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(viewed)); } catch(e) {}

    /* Render recently viewed (exclude current product) */
    const items = viewed.filter(p => p.id !== pid).slice(0, 8);
    if (!items.length) return;

    /* Fetch product data for each */
    const section = document.getElementById('pdp-recently-viewed');
    const track = document.getElementById('pdp-rv-track');
    if (!section || !track) return;

    Promise.all(items.map(item =>
      fetch('/products/' + item.handle + '.json')
        .then(r => r.json())
        .then(d => d.product)
        .catch(() => null)
    )).then(products => {
      const valid = products.filter(Boolean);
      if (!valid.length) { section.remove(); return; }
      const fmt = new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'});
      track.innerHTML = valid.map(p => {
        const img = p.images && p.images[0] ? p.images[0].src : '';
        const curPrice = parseFloat(p.variants[0].price) || 0;
        const compPrice = parseFloat(p.variants[0].compare_at_price) || 0;
        const onSale = compPrice > curPrice;
        let priceHtml = onSale
          ? '<div class="pdp__card-price pdp__card-price--sale">'+fmt.format(curPrice)+'<span class="pdp__card-compare">'+fmt.format(compPrice)+'</span></div>'
          : '<div class="pdp__card-price">'+fmt.format(curPrice)+'</div>';
        return '<a href="/products/'+p.handle+'" class="pdp__card"><img src="'+img+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" loading="lazy"><div class="pdp__card-body"><div class="pdp__card-title">'+p.title+'</div>'+priceHtml+'<span class="pdp__card-cta">View Product →</span></div></a>';
      }).join('');
      section.style.display = '';
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initRecentlyViewed); } else { initRecentlyViewed(); }

  /* ===== OVERVIEW LAYOUT — Tabbed (Bathify-style) ===== */
  function initOverviewLayout() {
    const descEl = document.getElementById('pdp-description');
    const textEl = document.getElementById('pdp-overview-text');
    const featEl = document.getElementById('pdp-feat-list');
    const detailsEl = document.getElementById('pdp-overview-details');
    const galleryEl = document.getElementById('pdp-overview-gallery');
    const descSection = document.getElementById('pdp-desc-section');
    const hasCustomCopy = descSection && descSection.dataset.customCopy === 'true';
    if (!descEl || !textEl || !featEl || !detailsEl) return;

    /* --- Tab switching (always bind, works for both paths) ---
       Entries without data-tab (anchor-link tabs like Reviews / Related Products)
       fall through to default <a href> scroll behavior — no tab state change. */
    document.querySelectorAll('.pdp__tab').forEach(tab => {
      tab.addEventListener('click', function(e) {
        if (!this.dataset.tab) return; /* anchor link — let browser scroll */
        document.querySelectorAll('.pdp__tab').forEach(t => t.classList.remove('pdp__tab--active'));
        document.querySelectorAll('.pdp__tab-panel').forEach(p => p.classList.remove('pdp__tab-panel--active'));
        this.classList.add('pdp__tab--active');
        const panel = document.querySelector('[data-panel="' + this.dataset.tab + '"]');
        if (panel) panel.classList.add('pdp__tab-panel--active');
      });
    });

    /* Skip description parsing when the PDP has curated copy server-rendered. */
    if (hasCustomCopy) return;
    if (!galleryEl) return;

    /* --- Parse description content --- */
    const features = [];
    descEl.querySelectorAll('li').forEach(li => {
      const text = li.textContent.trim();
      if (text && text.length > 3 && text.length < 200) features.push(text);
    });

    const paragraphs = [];
    descEl.querySelectorAll('p').forEach(p => {
      const text = p.textContent.trim();
      if (text.length > 30) paragraphs.push(p);
    });

    /* Split: first 3 paragraphs = About tab, rest = Details tab */
    const introParagraphs = [];
    const detailParagraphs = [];
    let introCount = 0;
    paragraphs.forEach(p => {
      const txt = p.textContent.trim().toLowerCase();
      if (txt.endsWith(':') && txt.length < 30) return;
      if (introCount < 3) {
        introParagraphs.push('<p>' + p.textContent.trim() + '</p>');
        introCount++;
      } else {
        detailParagraphs.push('<p>' + p.textContent.trim() + '</p>');
      }
    });

    /* Extract images for Gallery tab */
    const images = [];
    descEl.querySelectorAll('img').forEach(img => {
      const src = img.src || img.getAttribute('data-src') || '';
      if (!src) return;
      const alt = img.alt || '';
      const parent = img.closest('div') || img.parentElement;
      const caption = parent ? parent.textContent.replace(alt, '').trim() : '';
      images.push({ src, alt, caption });
    });

    /* Extract tables + headings for Details tab */
    const detailExtras = [];
    descEl.querySelectorAll('h2, h3, strong').forEach(el => {
      const text = el.textContent.trim();
      if (text.length > 3 && text.length < 100 && !text.toLowerCase().includes('feature')) {
        detailExtras.push('<h3>' + text + '</h3>');
      }
    });
    descEl.querySelectorAll('table').forEach(tbl => {
      detailExtras.push(tbl.outerHTML);
    });

    /* --- Render Tab 1: About This Item --- */
    textEl.innerHTML = introParagraphs.length ? introParagraphs.join('') : '<p>' + (desc || '').replace(/<[^>]+>/g, '').substring(0, 600) + '</p>';

    if (features.length) {
      featEl.innerHTML = features.slice(0, 10).map(f => '<li>' + f + '</li>').join('');
    } else {
      document.getElementById('pdp-overview-features').style.display = 'none';
      document.querySelector('.pdp__overview-grid').style.gridTemplateColumns = '1fr';
    }

    /* --- Render Tab 2: Details & Materials --- */
    const detailsHTML = detailParagraphs.join('') + detailExtras.join('');
    if (detailsHTML.trim()) {
      detailsEl.innerHTML = detailsHTML;
    } else {
      /* Hide tab if no detail content */
      const detailTab = document.querySelector('[data-tab="details"]');
      if (detailTab) detailTab.style.display = 'none';
    }

    /* --- Render Tab 3: Product Gallery --- */
    if (images.length) {
      galleryEl.innerHTML = images.map(img =>
        '<div>' +
        '<img src="' + img.src + '" alt="' + img.alt + '" loading="lazy">' +
        (img.caption ? '<p class="pdp__gallery-caption">' + img.caption + '</p>' : '') +
        '</div>'
      ).join('');
    } else {
      /* Hide gallery tab if no images */
      const galleryTab = document.querySelector('[data-tab="gallery"]');
      if (galleryTab) galleryTab.style.display = 'none';
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initOverviewLayout); } else { initOverviewLayout(); }

  /* ===== SPECS TABLE (parse from description) ===== */
  const specsTable = document.getElementById('pdp-specs-table');
  if (specsTable && desc) {
    const specs = [];
    const featureMatch = desc.match(/<li[^>]*>([^<]+(?:<[^>]+>[^<]*)*)<\/li>/gi);
    if (featureMatch) {
      featureMatch.slice(0, 12).forEach(li => {
        const text = li.replace(/<[^>]+>/g, '').trim();
        if (text && text.length > 5 && text.length < 200) {
          const parts = text.split(/[:\-–]/);
          if (parts.length >= 2) {
            specs.push({ key: parts[0].trim(), val: parts.slice(1).join(':').trim() });
          } else {
            specs.push({ key: 'Feature', val: text });
          }
        }
      });
    }
    if (specs.length) {
      specsTable.innerHTML = specs.map(s =>
        '<div class="pdp__spec-row"><div class="pdp__spec-key">'+s.key+'</div><div class="pdp__spec-val">'+s.val+'</div></div>'
      ).join('');
    }
  }

  /* v7.5 — clickable star rating: open the reviews <details> accordion and smooth scroll */
  (function bindRatingLink() {
    var ratingLink = document.querySelector('.pdp__rating-link');
    if (!ratingLink) return;
    ratingLink.addEventListener('click', function(e) {
      var target = document.getElementById('pdp-reviews-section');
      if (!target) return;
      e.preventDefault();
      if (target.tagName.toLowerCase() === 'details' && !target.open) {
        target.open = true;
      }
      var headerOffset = 80; /* account for sticky header */
      var y = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  /* Wishlist button wiring (Wave 5 of account pages build) */
  (function() {
    document.querySelectorAll('[data-hcs-wishlist-btn]').forEach(function(btn) {
      var product = {
        id: parseInt(btn.dataset.productId, 10),
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        price_cents: parseInt(btn.dataset.productPrice, 10),
        image: btn.dataset.productImage,
        url: btn.dataset.productUrl
      };
      function sync() {
        if (!window.HCSWishlist) return;
        var saved = window.HCSWishlist.has(product.id);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        btn.classList.toggle('is-saved', saved);
      }
      sync();
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!window.HCSWishlist) return;
        window.HCSWishlist.toggle(product);
        sync();
      });
      document.addEventListener('hcs:wishlist:change', sync);
    });
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
